
import { Product } from "@/types/product";
import { ImageGallery } from "./product/ImageGallery";
import { ProductInfo } from "./product/ProductInfo";
import { ProductTabs } from "./product/ProductTabs";
import { useLanguage } from "@/contexts/LanguageContext";

interface ProductDetailsProps {
  product: Product;
}

export const ProductDetails = ({ product }: ProductDetailsProps) => {
  const { t } = useLanguage();
  // Extract the image from the product or use an empty array if not available
  const images = product.images || (product.image ? [product.image] : []);

  // Check if this is a VPX product, DSP product, or DIDO X4 specifically that should show the logos
  const showVPXLogos = product.id === "vpx-tc1-lt" || product.id === "vpx-tc1-pro" || product.groupId === "audio-dsps" || product.id === "DIDO-X4";

  return (
    <div className="animate-fade-up space-y-8">
      <div className="grid gap-8 lg:grid-cols-2">
        <ImageGallery 
          images={images}
          productName={t(product.name)}
          showVPXLogos={showVPXLogos}
          applicationDiagram={product.applicationDiagram}
        />
        
        <ProductInfo 
          name={product.name}
          description={product.description}
          id={product.id}
        />
      </div>

      <ProductTabs 
        description={product.description}
        features={product.features}
        specifications={product.specifications}
        isHDBaseT={product.groupId === "hdbaset"}
      />
    </div>
  );
};
